import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridTipoOutro = ({ codigoFamilia, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [tiposOptions, setTiposOptions] = useState([]);
  const [itens, setItens] = useState([]);
  const [tipoSel, setTipoSel] = useState(null);
  const [dias, setDias] = useState('');
  const [percentual, setPercentual] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregarDados = () => {
    if (!codigoFamilia) return;
    api.listarTipoOutroConfig(codigoFamilia)
      .then((res) => {
        const lista = res && res.data ? res.data : (res || []);
        setItens(Array.isArray(lista) ? lista : []);
      })
      .catch(() => {});
  };

  useEffect(() => {
    carregarDados();
  }, [codigoFamilia]);

  useEffect(() => {
    if (!showForm) return;
    api.listarTiposComissaoConfig()
      .then((res) => {
        const lista = res && res.data ? res.data : (res || []);
        const opts = (Array.isArray(lista) ? lista : []).map((t) => ({
          value: t.codigo,
          label: t.codigo + ' - ' + t.descricao,
        }));
        setTiposOptions(opts);
      })
      .catch(() => {});
  }, [showForm]);

  const handleAbrirForm = () => {
    setTipoSel(null);
    setDias('');
    setPercentual('');
    setShowForm(true);
  };

  const handleIncluir = async () => {
    if (tipoSel == null) {
      toast.warn('Selecione o tipo.');
      return;
    }
    if (dias === '' || Number(dias) <= 0) {
      toast.warn('Informe os dias.');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirTipoOutroConfig({
        codigo_familia: codigoFamilia,
        codigo_tipo: tipoSel.value,
        dias: Number(dias),
        percentual: percentual !== '' ? Number(percentual) : null,
      });
      toast.success('Tipo incluído com sucesso!');
      setShowForm(false);
      carregarDados();
      if (onRecarregar) onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir tipo';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir tipo ' + item.descricao + '?')) return;
    try {
      await api.excluirTipoOutroConfig({
        codigo_familia: codigoFamilia,
        codigo_tipo: item.codigo_tipo,
      });
      toast.success('Tipo excluído!');
      carregarDados();
      if (onRecarregar) onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir tipo';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Hierarquia - Tipo Outro</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo</Form.Label>
                  <Select
                    options={tiposOptions}
                    value={tipoSel}
                    onChange={setTipoSel}
                    placeholder="Selecione tipo..."
                    isClearable
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    value={dias}
                    onChange={(e) => setDias(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">%</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    value={percentual}
                    onChange={(e) => setPercentual(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Descrição</th>
              <th>Nível</th>
              <th>Dias</th>
              <th>%</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {itens.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  Nenhum tipo outro cadastrado
                </td>
              </tr>
            )}
            {itens.map((item) => (
              <tr key={item.codigo_tipo}>
                <td>{item.codigo_tipo}</td>
                <td>{item.descricao}</td>
                <td>{item.nivel}</td>
                <td>{item.dias}</td>
                <td>{item.percentual}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridTipoOutro;
